export default {
  homepage: {
    topDealsTag: "688d0b25-c128-42b1-837e-2dbda9f8b7e2",
    topDeals: "Top Deals des Tages",
    currentDealsTitle: "Aktuelle Deals",
    currentDealsSubline:
      "Hier findet ihr alle verfügbaren Deals auf einen Blick",
    buttonText: "Zu den Deals",

    tagSection_1_tagImage: "/assets/images/home-mood/destination_spain",
    tagSection_1_tagId: "61b41f42-ad02-43b6-8b9c-84f76df54e63",
    tagSection_1_title: "Pauschalreisen",
    tagSection_1_subline: "Hier findet ihr das passende Rundum-Sorglos Paket",

    tagSection_2_tagImage: "/assets/images/home-mood/tag_short-trip",
    tagSection_2_tagId: "7f548400-c363-4381-b434-049ce82f0fa6",
    tagSection_2_title: "Kurzurlaub",
    tagSection_2_subline: "Entdeckt aktuelle Angebote für eine kleine Auszeit",

    tagSection_3_tagImage: "/assets/images/home-mood/tag_flexcancel",
    tagSection_3_tagId: "92f90b86-822a-427a-930d-f5f920ada826",
    tagSection_3_title: "Wellness",
    tagSection_3_subline:
      "Die besten Angebote für eine erholsame Wellnessauszeit",

    promotionSection_link: "https://urlaubsguru.de/adventskalender-2020",
    promotionSection_title: "Der große Adventskalender",
    promotionSection_subline:
      "Mitmachen und täglich eine von 24 Reisen gewinnen!",

    partnerSection_link:
      "https://buchen.urlaubsguru.de/region?dur=7&ibe=hotel&ddate=2018-08-15&rdate=2018-09-29&adult=2&_ga=2.178471271.252352868.1598601230-2100991080.1590410166/suchen-und-buchen/;desktop;",
    partnerSection_title: "Hotelsuche",
    partnerSection_subline: "Unterkünfte, wie ihr sie braucht",
    noMoreDealsInfo: "keine weiteren Angebote vorhanden"
  },
  supportPersonImageSrc: "/assets/images/callcenter/lena.jpg",

  magazine: {
    section: {
      link: "https://www.urlaubsguru.de/reisemagazin/",
      image: "/assets/images/magazine/de.jpg"
    }
  },

  deutschlandLiebe: {
    section: {
      link: "https://www.urlaubsguru.de/deutschlandliebe/",
      image: "/assets/images/banners/urlaub_in_deutschland.jpg"
    }
  },

  raffle: {
    link: "https://www.urlaubsguru.de/kreta-ostergewinnspiel/"
  },

  partnerList: {
    headline: "Weitere Reisearten",
    subline: "Urlaub, wie ihr ihn braucht",
    data: [
      {
        label: "Hotels",
        sub: "Die perfekte Unterkunft",
        url: "https://hotels.urlaubsguru.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_hotels.png"
      },
      {
        label: "Flüge",
        sub: "Günstige Flüge weltweit",
        url: "https://www.urlaubsguru.de/flugsuche/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fluege.png"
      },
      {
        label: "Kurzreisen",
        sub: "Kurz mal weg mit Wellness, Events & mehr",
        url: "https://kurzreisen.urlaubsguru.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kurzreisen.png"
      },

      {
        label: "Blind Booking",
        sub: "Überraschungstrip mit eigener Anreise",
        url: "https://blookery.urlaubsguru.de/eigene-anreise.html?utm_source=urlaubsguru&utm_campaign=urlaubsguru-suchen-und-buchen&utm_medium=banner&utm_content=kachel-section",
        image: "/assets/images/teasercards/Kachel_WL_368x180_blind_booking.png"
      },
      {
        label: "Hotelgutscheine",
        sub: "Top Auswahl der besten Hotelgutscheine",
        url: "https://hotelgutscheine.urlaubsguru.de/ ",
        image:
          "/assets/images/teasercards/Kachel_WL_368x180_hotelgutscheine.png"
      },
      {
        label: "Last Minute",
        sub: "Last Minute Angebote zum kleinen Preis",
        url: "https://www.urlaubsguru.de/last-minute-angebote/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_fruehbucher.png"
      },
      {
        label: "Städtereisen",
        sub: "Citytrips mit Flug & Hotel",
        url: "https://staedtereisen.urlaubsguru.de/de-de/galerie",
        image: "/assets/images/teasercards/Kachel_WL_368x180_staedtereisen.png"
      },
      {
        label: "Ferienwohnungen",
        sub: "Günstige Ferienwohnungen im Vergleich ",
        url: "https://ferienhaus.urlaubsguru.de/",
        image:
          "/assets/images/teasercards/Kachel_WL_368x180_ferienwohnungen.png"
      },
      {
        label: "Skireisen",
        sub: "Skiurlaub - preiswert wie nie zuvor",
        url: "https://skireisen.urlaubsguru.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_skireisen.png"
      },
      {
        label: "Rundreisen",
        sub: "Rundreisen weltweit zum Bestpreis",
        url: "https://rundreisen.urlaubsguru.de/de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_rundreise.png"
      },
      {
        label: "Mietwagen",
        sub: "Preiswerte Mietwagen im Vergleich",
        url: "https://www.urlaubsguru.de/mietwagen/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_mietwagen.png"
      },
      {
        label: "Gutscheine",
        sub: "Exklusive Urlaubsguru-Gutscheine",
        url: "https://urlaubsguru-gutschein.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_gutschein.png"
      },
      {
        label: "Kreuzfahrten",
        sub: "Günstige Kreuzfahrten im Vergleich",
        url: "https://kreuzfahrten.urlaubsguru.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_kreuzfahrten.png"
      },
      {
        label: "Bahnreisen",
        sub: "Die perfekte Städtereise mit der Bahn",
        url: "https://bahnreisen.urlaubsguru.de/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_bahnreisen.png"
      },
      {
        label: "Pauschalreisen",
        sub: "Reisen mit allem was dazu gehört",
        url: "https://buchen.urlaubsguru.de",
        image: "/assets/images/teasercards/Kachel_WL_368x180_pauschalreisen.png"
      },
      {
        label: "Reiseanfrage",
        sub: "Stellt jetzt eure individuelle Reiseanfrage",
        url: "https://www.urlaubsguru.de/individuelle-reiseanfrage/",
        image: "/assets/images/teasercards/Kachel_WL_368x180_reiseanfragen.png"
      }
    ]
  },

  linkList: [
    {
      label: "Beliebte Urlaubsziele",
      links: [
        {
          label: "Günstige Urlaubsziele",
          url: "https://www.urlaubsguru.de/urlaubsziele/"
        },

        {
          label: "Kroatien Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/kroatien/"
        },

        {
          label: "Mallorca Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/mallorca-urlaub/"
        },
        {
          label: "Griechenland Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/griechenland-urlaub/"
        },
        {
          label: "Bulgarien Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/bulgarien-urlaub/"
        },
        {
          label: "Italien Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/italien-urlaub/"
        },
        {
          label: "Teneriffa Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/teneriffa-urlaub/"
        },
        {
          label: "Kreta Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/kreta-urlaub/"
        }
      ]
    },
    {
      label: "Urlaubsziele weltweit",
      links: [
        {
          label: "Ägypten Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/aegypten-urlaub/"
        },
        {
          label: "Thailand Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/thailand/"
        },
        {
          label: "Türkei Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/tuerkei-urlaub/"
        },
        {
          label: "Zypern Urlaub ",
          url: "https://www.urlaubsguru.de/urlaubsziele/zypern-urlaub/"
        },
        {
          label: "DomRep Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/dominikanische-republik/"
        },
        {
          label: "Malta Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/malta-urlaub/"
        },
        {
          label: "Algarve Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/algarve/"
        },
        {
          label: "Österreich Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/oesterreich/"
        }
      ]
    },
    {
      label: "Deutschlandliebe",
      links: [
        {
          label: "Urlaub in Deutschland",
          url: "https://www.urlaubsguru.de/deutschlandliebe/"
        },
        {
          label: "Ostsee Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/ostsee/"
        },
        {
          label: "Nordsee Urlaub",
          url: "https://www.urlaubsguru.de/urlaubsziele/nordsee/"
        },
        {
          label: "Allgäu Urlaub",
          url: "https://www.urlaubsguru.de/deutschlandliebe/allgaeu/"
        },
        {
          label: "Bayern Urlaub",
          url: "https://www.urlaubsguru.de/deutschlandliebe/bayern/"
        },
        {
          label: "Mecklenburgische Seenplatte Urlaub",
          url: "https://www.urlaubsguru.de/deutschlandliebe/mecklenburg-vorpommern/"
        },
        {
          label: "Harz Urlaub",
          url: "https://www.urlaubsguru.de/deutschlandliebe/harz/"
        },
        {
          label: "Schwarzwald Urlaub",
          url: "https://www.urlaubsguru.de/deutschlandliebe/schwarzwald/"
        }
      ]
    },
    {
      label: "Reisearten",
      links: [
        {
          label: "Kurzurlaub",
          url: "https://www.urlaubsguru.de/kurzreisen/"
        },
        {
          label: "Pauschalreisen",
          url: "https://www.urlaubsguru.de/pauschalreisen/"
        },
        {
          label: "Rundreisen",
          url: "https://www.urlaubsguru.de/rundreisen/"
        },
        {
          label: "All Inclusive",
          url: "https://www.urlaubsguru.de/all-inclusive/"
        },
        {
          label: "Familienurlaub",
          url: "https://www.urlaubsguru.de/familienurlaub/"
        },
        {
          label: "Singlereisen",
          url: "https://www.urlaubsguru.de/singlereisen/"
        },
        {
          label: "Frühbucher",
          url: "https://www.urlaubsguru.de/fruehbucher/"
        },
        {
          label: "Wanderurlaub",
          url: "https://www.urlaubsguru.de/wanderurlaub/"
        }
      ]
    },
    {
      label: "Last Minute Angebote",
      links: [
        {
          label: "Last Minute",
          url: "https://www.urlaubsguru.de/last-minute/"
        },
        {
          label: "Last Minute Kreta",
          url: "https://www.urlaubsguru.de/last-minute/kreta/"
        },
        {
          label: "Last Minute Dubai",
          url: "https://www.urlaubsguru.de/last-minute/dubai/"
        },
        {
          label: "Last Minute Griechenland",
          url: "https://www.urlaubsguru.de/last-minute/griechenland/"
        },
        {
          label: "Last Minute Kanaren",
          url: "https://www.urlaubsguru.de/last-minute/kanaren/"
        },
        {
          label: "Last Minute Türkei",
          url: "https://www.urlaubsguru.de/last-minute/tuerkei/"
        },
        {
          label: "Last Minute New York",
          url: "https://www.urlaubsguru.de/last-minute/new-york/"
        },
        {
          label: "Last Minute Mallorca",
          url: "https://www.urlaubsguru.de/last-minute/mallorca/"
        }
      ]
    },
    {
      label: "Wellness",
      links: [
        {
          label: "Wellnessurlaub",
          url: "https://www.urlaubsguru.de/wellness/"
        },
        {
          label: "Wellness Deutschland",
          url: "https://www.urlaubsguru.de/wellness/deutschland/"
        },
        {
          label: "Wellness Bayern",
          url: "https://www.urlaubsguru.de/wellness/bayern/"
        },
        {
          label: "Wellness Ostsee",
          url: "https://www.urlaubsguru.de/wellness/ostsee/"
        },
        {
          label: "Wellness Holland",
          url: "https://www.urlaubsguru.de/wellness/niederlande/"
        },
        {
          label: "Wellness in Österreich",
          url: "https://www.urlaubsguru.de/wellness/oesterreich/"
        },
        {
          label: "Wellness Italien",
          url: "https://www.urlaubsguru.de/wellness/italien/"
        },
        {
          label: "Wellnesshotel",
          url: "https://www.urlaubsguru.de/tag/wellnesshotel/"
        }
      ]
    },
    {
      label: "Städtereisen Angebote",
      links: [
        {
          label: "Städtereisen",
          url: "https://www.urlaubsguru.de/staedtereisen/"
        },
        {
          label: "Städtereise Paris",
          url: "https://www.urlaubsguru.de/tag/paris/"
        },
        {
          label: "Städtereise Wien",
          url: "https://www.urlaubsguru.de/urlaubsziele/wien/"
        },
        {
          label: "Städtereise Prag",
          url: "https://www.urlaubsguru.de/tag/prag/"
        },
        {
          label: "Städtereise Barcelona",
          url: "https://www.urlaubsguru.de/urlaubsziele/barcelona/"
        },
        {
          label: "Städtereise Amsterdam",
          url: "https://www.urlaubsguru.de/tag/amsterdam/"
        },
        {
          label: "Städtereise Rom",
          url: "https://www.urlaubsguru.de/urlaubsziele/rom/"
        },
        {
          label: "Städtereise Berlin",
          url: "https://www.urlaubsguru.de/deutschlandliebe/berlin/"
        }
      ]
    },
    {
      label: "Informationen",
      links: [
        {
          label: "Reisemagazin",
          url: "https://www.urlaubsguru.de/reisemagazin/"
        },
        {
          label: "Tipps & Tricks",
          url: "https://www.urlaubsguru.de/magazin-tag/tipps-tricks/"
        },
        {
          label: "Corona FAQ",
          url: "https://www.urlaubsguru.de/corona/"
        },
        {
          label: "Reisekalender",
          url: "https://www.urlaubsguru.de/reisekalender/"
        },
        {
          label: "Sehenswürdigkeiten",
          url: "https://www.urlaubsguru.de/urlaubsziele/sehenswuerdigkeiten/"
        },
        {
          label: "Silvesterreisen 2020/21",
          url: "https://www.urlaubsguru.de/reisekalender/silvester/"
        },
        {
          label: "Freizeitaktivitäten",
          url: "https://www.urlaubsguru.de/freizeitaktivitaeten/"
        },
        {
          label: "Lexikon",
          url: "https://www.urlaubsguru.de/lexikon/"
        }
      ]
    }
  ],

  footer: {
    corporate: {
      label: "Unternehmen",
      data: [
        {
          label: "Über Urlaubsguru",
          url: "https://www.urlaubsguru.de/ueber-uns/"
        },
        {
          label: "Jobs",
          url: "https://www.urlaubsguru.de/jobs/"
        },
        {
          label: "Werbung",
          url: "https://www.urlaubsguru.de/werbung/"
        },
        {
          label: "Presse",
          url: "https://www.urlaubsguru.de/presse/"
        }
      ]
    },
    informations: {
      label: "Informationen",
      data: [
        {
          label: "Corona Reiseinformationen",
          url: "https://www.urlaubsguru.de/corona/"
        },
        {
          label: "Buchen beim Urlaubsguru",
          url: "https://www.urlaubsguru.de/suchen-buchen-bei-urlaubsguru/"
        },
        {
          label: "Dein Feedback an Uns",
          url: "https://www.urlaubsguru.de/urlaubsguru-feedback/"
        },
        {
          label: "Nachhaltig Reisen",
          url: "https://www.urlaubsguru.de/nachhaltiger-tourismus/"
        }
      ]
    },
    buttons: [
      {
        label: "Datenschutz",
        url: "https://www.urlaubsguru.de/datenschutzerklaerung/"
      },
      {
        label: "Sitemap",
        url: "https://www.urlaubsguru.de/sitemap/"
      },
      {
        label: "Schlagworte",
        url: "https://www.urlaubsguru.de/tag/"
      },
      {
        label: "Impressum / Rechtliche Hinweise",
        url: "https://www.urlaubsguru.de/impressum/"
      }
    ],
    social: {
      label: "Folgt uns auf",
      data: [
        {
          label: "Facebook",
          icon: "facebook",
          url: "https://www.facebook.com/derurlaubsguru/"
        },
        {
          label: "Instagram",
          icon: "instagram",
          url: "https://www.instagram.com/urlaubsguru/"
        },
        {
          label: "TikTok",
          icon: "tiktok",
          url: "https://www.tiktok.com/@urlaubsguru.de"
        },
        {
          label: "YouTube",
          icon: "youtube",
          url: "https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g"
        }
      ]
    },
    newsletter: {
      label: "Meldet euch für den Newsletter an",
      button: "Zum Newsletter",
      url: "https://www.urlaubsguru.de/urlaubsguru-newsletter/"
    },
    app: {
      label: "Ladet euch die App herunter",
      apple:
        "https://apps.apple.com/de/app/urlaubsguru-reise-schn%C3%A4ppchen/id692735087",
      android: "https://play.google.com/store/apps/details"
    }
  },

  skiSearchControls: {
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: "any"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "1-2 Nächte",
        value: "1,2"
      },
      {
        name: "2-5 Nächte",
        value: "2,5"
      },
      {
        name: "5-9 Nächte",
        value: "5,9"
      },
      {
        name: "9-11 Nächte",
        value: "9,11"
      },
      {
        name: "1 Nacht",
        value: "1,1"
      },
      {
        name: "2 Nächte",
        value: "2,2"
      },
      {
        name: "3 Nächte",
        value: "3,3"
      },
      {
        name: "4 Nächte",
        value: "4,4"
      },
      {
        name: "5 Nächte",
        value: "5,5"
      },
      {
        name: "6 Nächte",
        value: "6,6"
      },
      {
        name: "7 Nächte",
        value: "7,7"
      },
      {
        name: "8 Nächte",
        value: "8,8"
      },
      {
        name: "9 Nächte",
        value: "9,9"
      },
      {
        name: "10 Nächte",
        value: "10,10"
      },
      {
        name: "11 Nächte",
        value: "11,11"
      }
    ]
  },

  ibeSearchControls: {
    dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    durationOptions: [
      {
        name: "exakt wie angegeben",
        value: "exact"
      },
      {
        name: "beliebig",
        value: ""
      },
      {
        name: "2 - 4 Tage",
        value: "1,3"
      },
      {
        name: "5 - 8 Tage",
        value: "4,7"
      },
      {
        name: "9 - 12 Tage",
        value: "8,11"
      },
      {
        name: "10  Tage",
        value: "9"
      },
      {
        name: "1 Wochenende",
        value: "2"
      },
      {
        name: "1 Woche",
        value: "7"
      },
      {
        name: "2 Wochen",
        value: "14"
      }
    ],
    childAgeOptions: [
      { label: "< 2 Jahre", value: 1 },
      { label: "2 Jahre", value: 2 },
      { label: "3 Jahre", value: 3 },
      { label: "4 Jahre", value: 4 },
      { label: "5 Jahre", value: 5 },
      { label: "6 Jahre", value: 6 },
      { label: "7 Jahre", value: 7 },
      { label: "8 Jahre", value: 8 },
      { label: "9 Jahre", value: 9 },
      { label: "10 Jahre", value: 10 },
      { label: "11 Jahre", value: 11 },
      { label: "12 Jahre", value: 12 },
      { label: "13 Jahre", value: 13 },
      { label: "14 Jahre", value: 14 },
      { label: "15 Jahre", value: 15 },
      { label: "16 Jahre", value: 16 },
      { label: "17 Jahre", value: 17 }
    ]
  },
  jsonLD: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Urlaubsguru",
    url: "https://www.urlaubsguru.de/",
    logo: "https://www.urlaubsguru.de/wp-content/uploads/2016/04/logo_dummy_x2-400x87.png",
    sameAs: [
      "https://www.facebook.com/derurlaubsguru/",
      "https://twitter.com/urlaubsguru_de?lang=de",
      "https://www.pinterest.de/urlaubsguru/",
      "https://www.instagram.com/urlaubsguru/?hl=de",
      "https://www.youtube.com/channel/UCKDLTlnI9j6lyP6CyTp293g"
    ]
  },
  searchCustomLinks: [
    {
      label: "Kurzreisen",
      url: "https://kurzreisen.urlaubsguru.de/getaways",
      icon: "deck-chair-sun"
    }
  ],
  privacyManagerModalId: "546579",
  destination_category_destination: "Regionen",
  destination_category_region: "Regionen",
  destination_category_accommodation: "Hotels",
  destination_category_city: "Städte",
  destination_category_poi: "Sehenswürdigkeiten",
  destination_category_point_of_interest: "Sehenswürdigkeiten",
  destination_category_multi_city_vicinity: "Gebiete",
  destination_category_province_state: "Regionen",
  destination_category_neighborhood: "Umgebungen",
  destination_category_airport: "Flughäfen",
  destination_category_train_station: "Bahnstationen",
  destination_category_metro_station: "Metrostationen",
  destination_category_continent: "Kontinente",
  destination_category_country: "Länder",
  destination_category_high_level_region: "Gebiete",

  newsletter: {
    title: "Dein Urlaubsguru-Newsletter",
    info: "Du suchst nach <strong>hilfreichen Reiseempfehlungen und Top Deals?</strong> Dann melde dich für den exklusiven Urlaubsguru Newsletter an. <br /> <br />Das erwartet dich:",
    listItem1: "handverlesene Angebote von den Urlaubsguru-Reiseexperten",
    listItem2: "Deals mit unschlagbarem Preisleistungsverhältnis",
    listItem3: "Inspiration und hilfreiche Tipps für deine nächste Reise",
    button: "Newsletter anmelden"
  },
  amadeusPackageTourSearch: {
    infoTextSingleRoom: "Alle Personen werden in einem Zimmer untergebracht. Wünscht ihr eine andere Zimmeraufteilung, ruft uns an:"
  }
}
